import { render, staticRenderFns } from "./HistoryHornos.vue?vue&type=template&id=5fb63c6f&lang=true"
import script from "./HistoryHornos.vue?vue&type=script&lang=js"
export * from "./HistoryHornos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports